import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '../service/auth.service';

/**
 * Gate routes behind a stored API key. Unauthenticated visitors are redirected
 * to the homepage instead of seeing the settings UI. The key is validated
 * against the backend when it's entered (see AppComponent.validateAndSaveKey),
 * so a stored key is a previously-valid one — and the backend re-checks every
 * request regardless, so this guard is a UX gate, not the security boundary.
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  return authService.isAuthenticated() ? true : router.createUrlTree(['/home']);
};
